import {configureStore} from "@reduxjs/toolkit";
import loginReducer from "./Slices/Pages/Auth/LoginSlice";
import profileReducer from "./Slices/Pages/UserProfile/ProfileSlice";
import servicesReducer from "./Slices/Pages/services/servicesSlice";
import jobsReducer from "./Slices/Pages/Jobs/JobsSlice";
import proposalReducer from "./Slices/Pages/Proposal/ProposalSlice";


const store = configureStore({
reducer:{
   login:loginReducer,
   profile:profileReducer,
   services:servicesReducer,
   jobs:jobsReducer,
   proposal:proposalReducer,
}
});

export default store;
